export const CONTROL_EVIDENCE_LABELS = {
  noEvidence:
    'Lema has not found any indication that this control is violated. We are continuing to monitor it.',
  lemaAiInsights: 'Lema AI insights',
  details: 'Details',
} as const
